import logo from './logo.svg';
import './App.css';
import { Routes, Route, Navigate, useLocation, useParams } from "react-router-dom";
import LoginPage from "./screens/Auth/Login";
import SignupPage from "./screens/Auth/CreateAccount";
import TostMessageComponent from "./TostMessageComponent/TostMessageComponent";
import DashboardScreen from './screens/Dashboard/dashboard';
import AssignmentsScreen from './screens/Dashboard/assignments';
import EnrollScreen from './screens/Dashboard/enroll';
import TimetableScreen from './screens/Dashboard/timetable';
import CreateChildScreen from './screens/Dashboard/create-child';
import ManageChildScreen from './screens/Dashboard/manage-child';
import ChooseChildPage from './screens/Auth/ChooseChild';
import ConfirmEnrollmentScreen from './screens/Dashboard/confirm-enrollment';
import MyClassesScreen from './screens/Dashboard/my-classes';
import ProfileScreen from './screens/Dashboard/profile';
import SubscriptionsScreen from './screens/Dashboard/subscriptions';
import ResetPage from './screens/Auth/ResetPassword';
import ChangePasswordPage from './screens/Auth/ChangePassword';
import ConfirmPrivateEnrollmentScreen from './screens/Dashboard/confirm-private-enrollment';
import SubSuccessScreen from './screens/Dashboard/subscription-success';
import EditChildScreen from './screens/Dashboard/edit-child';
import { UserContext } from './context/UserContext';
import { useContext, useEffect } from 'react';
import { useCookies } from 'react-cookie';

function App() {
  const {setUserProfile, logOutFunction, reloadUser} = useContext(UserContext);
  const [cookies, setCookie, removeCookie] = useCookies();
  const location = useLocation();
  const {token} = useParams();

  useEffect(() => {
    // console.log(location, location.pathname.split("/").filter(Boolean)[0]);
    if (location.pathname != "/login" && location.pathname != "/create-account" && location.pathname != "/select-child" && location.pathname != "/reset-password" && location.pathname.split("/").filter(Boolean)[0] != "change-password") {
      if (cookies?.userProfile != null) {
        setUserProfile(cookies?.userProfile);
      } else {
        logOutFunction();
      }
    }
  }, [])

  return (
    <div>
      <TostMessageComponent />
      <Routes>
        <Route exact path='/' element={<Navigate replace to='/login' />} />
        <Route exact path='/login' element={<LoginPage />} />
        <Route exact path='/reset-password' element={<ResetPage />} />
        <Route exact path='/change-password/:token' element={<ChangePasswordPage />} />
        <Route exact path='/login' element={<LoginPage />} />
        <Route exact path='/select-child' element={<ChooseChildPage />} />
        <Route exact path='/create-account' element={<SignupPage />} />
        <Route exact path='/home' element={<DashboardScreen />} />
        <Route exact path='/timetable' element={<TimetableScreen />} />
        <Route exact path='/enroll' element={<EnrollScreen />} />
        <Route exact path='/tasks' element={<AssignmentsScreen />} />
        <Route exact path='/create-child' element={<CreateChildScreen />} />
        <Route exact path='/manage-child' element={<ManageChildScreen />} />
        <Route exact path='/enroll/confirm-enrollment' element={<ConfirmEnrollmentScreen />} />
        <Route exact path='/enroll/confirm-private-enrollment' element={<ConfirmPrivateEnrollmentScreen />} />
        <Route exact path='/subscriptions' element={<SubscriptionsScreen />} />
        <Route exact path='/success' element={<SubSuccessScreen />} />
        <Route exact path='/edit-child' element={<EditChildScreen />} />
        <Route exact path='/my-classes' element={<MyClassesScreen />} />
        <Route exact path='/my-profile' element={<ProfileScreen />} />
      </Routes>
    </div>
  );
}

export default App;
